import { Component, computed, effect, inject, Input, OnInit, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { RekbotSettings } from '../../../models/rekbot-settings.model';
import {
  //  AbstractControl, 
  //  FormGroup, 
  FormsModule,
  //  ValidationErrors 
} from '@angular/forms';
import { RekbotsService } from '../../../services/rekbots.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RekbotSettingsOpenHours } from '../../../models/rekbot-settings-open-hours.model';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RekbotDayOpenHoursComponent } from '../../rekbot-day-open-hours/rekbot-day-open-hours.component';
import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import {
  MatSnackBar,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { NotificationService } from '../../../services/notification.service';
//import { BehaviorSubject, merge, Subscription } from 'rxjs';
import { RekbotSettingsEmailListComponent } from '../../rekbot-settings-email-list/rekbot-settings-email-list.component';
import { EmailListService } from '../../../services/email-list.service';
//import { Store } from '@ngrx/store';
import { AlertListService } from '../../../services/alert-list.service';
//import { Display } from '../../models/display.model';
//import { scanner } from '../../models/scanner.model';
import { MatSelectModule } from '@angular/material/select';
import { Rekbot } from '../../../models/rekbot.model';
import { SmtpConfig } from '../../../models/smtp-config.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SettingsSmtpTableComponent } from '../../../settings/settings-smtp-table/settings-smtp-table.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { PermissionsService } from '../../../services/permissions.service';
import { AuthService } from '../../../services/auth.service';
import { RekbotStateService } from '../rekbot-layout-services/rekbot-state.service';
import { finalize, take } from 'rxjs';

interface Display {
  value: string
}

interface Scanner {
  value: string
}

@Component({
  selector: 'app-rekbot-settings',
  standalone: true,
  imports: [
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatSliderModule,
    FormsModule,
    CommonModule,
    MatProgressSpinnerModule,
    RekbotDayOpenHoursComponent,
    CdkTextareaAutosize,
    TextFieldModule,
    RekbotSettingsEmailListComponent,
    SettingsSmtpTableComponent,
    MatCardModule,
    MatButtonModule
  ],
  templateUrl: './rekbot-settings.component.html',
  styleUrl: './rekbot-settings.component.css'
})
export class RekbotSettingsComponent implements OnInit {

  //private _snackBar = inject(MatSnackBar);
  durationInSeconds = 5;

  public displays: Array<Display> = [
    {
      value: "HDMI"
    },
  ];

  public scanners: Array<Scanner> = [
    {
      value: "Newland NLS-FM431-U"
    }
  ];

  @ViewChild('SMTPModal') SMTPModal: any;

  public checked: boolean = false
  public disabled: boolean = false

  public elementId: number = 0;

  public open_hours?: RekbotSettingsOpenHours;

  public settingsExist: boolean = false;

  public rekbot?: Rekbot;

  public rekbotAccounts: SmtpConfig[] = [];


  public rekbotTimeValidation: Array<Array<Signal<boolean>>> = [
    [signal(false), signal(false)],
    [signal(false), signal(false)],
    [signal(false), signal(false)],
    [signal(false), signal(false)],
    [signal(false), signal(false)],
    [signal(false), signal(false)],
    [signal(false), signal(false)]
  ];

  public checkTimeValidation: Signal<boolean> = computed(() => {

    return this.rekbotTimeValidation[0][0]() || this.rekbotTimeValidation[0][1]() ||
      this.rekbotTimeValidation[1][0]() || this.rekbotTimeValidation[1][1]() ||
      this.rekbotTimeValidation[2][0]() || this.rekbotTimeValidation[2][1]() ||
      this.rekbotTimeValidation[3][0]() || this.rekbotTimeValidation[3][1]() ||
      this.rekbotTimeValidation[4][0]() || this.rekbotTimeValidation[4][1]() ||
      this.rekbotTimeValidation[5][0]() || this.rekbotTimeValidation[5][1]() ||
      this.rekbotTimeValidation[6][0]() || this.rekbotTimeValidation[6][1]()
  })


  public rekbotSettings: RekbotSettings = RekbotSettings.empty();


  constructor(
    private rekbotStateService: RekbotStateService,
    public rekbotsService: RekbotsService,
    public router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    public emailListService: EmailListService,
    public alertListService: AlertListService,
    private modalService: NgbModal,
    private authService: AuthService,
    private permissionsService: PermissionsService,

  ) {

    this.elementId = 0;
  }

  ngOnInit(): void {

    this.rekbotStateService.state$
    .pipe(take(1),finalize(() => console.log("rekbotStateService unsub in settings", this.rekbotSettings, this.rekbot)))
    .subscribe(state => {
      if (state.settings.rekbot_id) {
        console.log("Wgrane ustawienia dla: ",state,state.settings.rekbot_id);
        
        
        this.rekbotSettings = state.settings;
        this.rekbotSettings.open_hours = state.openHours;

        this.rekbot = state.rekbot
        this.elementId = state.rekbot.id

        if (this.rekbotSettings.email !== null) {
          this.emailListService.clearList();
          const emails = this.rekbotSettings.email.split(";");
          emails.forEach(item => this.emailListService.addEmail(item))
        }

        if (this.rekbotSettings.alert_email !== null) {
          this.alertListService.clearList();
          const emails = this.rekbotSettings.alert_email.split(";");
          emails.forEach(item => this.alertListService.addEmail(item))
        }

        this.settingsExist = true;

      } else {
        this.settingsExist = false;
      }

    })
  }

  isSuperadmin(): boolean {
    const user = this.authService.user;
    if (user) {
      return this.permissionsService.getUserPermissions(user) == 100;
    }
    return false;
    
  }

  // fetchRekbotSettings(): void {

  //   if (this.elementId > 0) {
  //     this.rekbotsService.fetchRekbotSettings(this.elementId)
  //       .subscribe({
  //         next: (response: any) => {

  //           console.log("rekbotsService.fetchRekbotSettings response", response)

  //           if (response.settings) {
  //             this.rekbotSettings = response.settings
  //             this.rekbotSettings.open_hours = response.openHours

  //             this.rekbot = response.rekbot

  //             if (this.rekbotSettings.email !== null) {
  //               this.emailListService.clearList();
  //               const emails = this.rekbotSettings.email.split(";");
  //               emails.forEach(item => this.emailListService.addEmail(item))
  //             }

  //             if (this.rekbotSettings.alert_email !== null) {
  //               this.alertListService.clearList();
  //               const emails = this.rekbotSettings.alert_email.split(";");
  //               emails.forEach(item => this.alertListService.addEmail(item))
  //             }

  //             this.settingsExist = true;

  //           } else {
  //             this.settingsExist = false;
  //           }


  //         },
  //         error: (error) => {
  //           console.log("fetchRekbotConfig error", error)
  //           if (error.status === 401) {
  //             this.router.navigate(['/']);
  //           }
  //         },
  //       });
  //   }
  // }

  currentEmails() {
    return signal(this.emailListService.getEmail());
  }

  updateRekbotSettings() {

    if (this.rekbotSettings.id) {

      console.log("updated list", this.emailListService.getEmail());

      const currentEmails = this.emailListService.getEmail();
      this.rekbotSettings.email = currentEmails;

      const alertEmails = this.alertListService.getEmail();
      this.rekbotSettings.alert_email = alertEmails;


      if (this.rekbotSettings.lat !== "" && this.rekbotSettings.lon !== "" &&
        this.rekbotSettings.lat !== undefined && this.rekbotSettings.lon !== undefined &&
        this.rekbotSettings.lat !== null && this.rekbotSettings.lon !== null) {

        this.rekbotSettings.lon = this.rekbotSettings.lon.replace(",", ".");
        this.rekbotSettings.lat = this.rekbotSettings.lat.replace(",", ".");
      }

      this.rekbotsService.updateRekbotSettings(this.elementId, this.rekbotSettings)
        .subscribe({
          next: (response: any) => {

            console.log("rekbotsService.updateRekbotSettings response", response)
            this.notificationService.pushNotification(
              `Konfiguracja Rekbot-a zaktualizowana`, 'info', 5000);

            // this.fetchRekbotSettings()
          },
          error: (error) => {
            console.log("fetchRekbotConfig error", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        });
    } else {
      this.rekbotsService.createRekbotSettings(this.elementId, this.rekbotSettings)
        .subscribe({
          next: (response: any) => {

            console.log("rekbotsService.createRekbotSettings response", response)

            this.notificationService.pushNotification(
              `Konfiguracja Rekbot-a utworzona!`, 'info', 5000);

            // this.fetchRekbotSettings()

          },
          error: (error) => {
            console.log("fetchRekbotConfig error", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        });

    }
  }

  saveSettings() {
    console.log("saveSettings", this.rekbotSettings)
    this.updateRekbotSettings()
  }

  eventChanged(event: Event) {
    console.log("eventChanged", this.rekbotSettings, event)
  }


  fetchDirectRekbotSettings(): void {

    this.rekbotsService.fetchSettingsFromRekbot(this.elementId)
      .subscribe({
        next: (response: any) => {

          console.log("rekbotsService.fetchSettingsFromRekbot response", response)

          if (response.status === 401) {

            this.notificationService.pushNotification(
              response.error, 'error', 5000);
          }

          if (response.status === 'curlError') {

            this.notificationService.pushNotification(
              response.curlError, 'error', 5000);
          }

          if (response.status === 200) {
            //alert(response.curlError);
            this.notificationService.pushNotification(
              `Ustawienia pobrane z Rekbot-a`, 'info', 5000);
          }

          // this.fetchRekbotSettings();
        },
        error: (error) => {
          console.log("fetchRekbotConfig error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  sendNewRekbotSettings() {

    this.rekbotsService.sendSettingsToRekbot(this.elementId, this.rekbotSettings)
      .subscribe({
        next: (response: any) => {
          console.log("rekbotsService.sendSettingsToRekbot response", response)

          if (response.status === 401) {
            this.notificationService.pushNotification(
              response.error, 'error', 5000);
          }

          if (response.status === 'curlError') {

            this.notificationService.pushNotification(
              response.curlError, 'error', 5000);
          }

          if (response.status === 200) {
            this.notificationService.pushNotification(
              `Ustawienia wysłane do Rekbot-a`, 'info', 5000);
          }

          // this.fetchRekbotSettings();
        },
        error: (error) => {
          console.log("fetchRekbotConfig error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  sendCurrentSMTPSetting() {
    this.rekbotsService.sendSmtpSettingsToRekbot(this.elementId)
      .subscribe({
        next: (response: any) => {
          console.log("rekbotsService.sendCurrentSMTPSetting response", response)

          if (response.status === 401) {
            this.notificationService.pushNotification(
              response.error, 'error', 5000);
          }

          if (response.status === 'curlError') {
            this.notificationService.pushNotification(
              response.curlError, 'error', 5000);
          }

          if (response.status === 200) {
            this.notificationService.pushNotification(
              `Ustawienia wysłane do Rekbot-a`, 'info', 5000);
          }

          //this.fetchRekbotSettings();
        },

        error: (error) => {
          console.log("fetchRekbotConfig error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  generateStoreAPIKey() {
    this.rekbotsService.generateStoreAPIKey(this.elementId)
      .subscribe({
        next: (response: any) => {
          console.log("rekbotsService.generateStoreAPIKey response", response)

          if (response.status === 401) {
            this.notificationService.pushNotification(
              response.error, 'error', 5000);
          }

          if (response.status === 'curlError') {
            this.notificationService.pushNotification(
              response.curlError, 'error', 5000);
          }

          if (response.status === 200) {
            this.notificationService.pushNotification(
              `Klucz wygenerowany, zapisz ustawienia, i wyślij do rekbot-a`, 'info', 10000);
          }
        },

        error: (error) => {
          console.log("generateStoreAPIKey error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  clearReceipts() {
    this.rekbotsService.clearReceipts(this.elementId)
      .subscribe({
        next: (response: any) => {
          console.log("rekbotsService.clearReceipts response", response)

          if (response.status === 401) {
            this.notificationService.pushNotification(
              response.error, 'error', 5000);
          }

          if (response.status === 'curlError') {
            this.notificationService.pushNotification(
              response.curlError, 'error', 5000);
          }

          if (response.status === 200) {
            this.notificationService.pushNotification(
              `Paragony wyczyszczone`, 'info', 5000);
          }
        },

        error: (error) => {
          console.log("clearReceipts error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }


  toConsole() {
    console.log(this.checkTimeValidation())
  }


  fetchSmtpFromRekbot() {
    //this.isLoading = true

    console.log("fetchSmtpFromRekbot this.rekbot", this.rekbot)


    if (this.rekbot !== undefined) {
      this.rekbotsService.fetchRekbotSmtp(this.rekbot.id)
        .subscribe({
          next: (response: any) => {
            console.log("fetchSmtpFromRekbot", response)
            this.rekbotAccounts = response.rekbotConfigResponse
            this.modalService.open(this.SMTPModal, { size: 'lg' });
          },
          error: (error) => {
            console.log("fetchSmtpFromRekbot error", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        });
    }
  }

  decodeLocationData() {
    if (this.rekbot !== undefined) {
      this.rekbotsService.decodeLocationData(this.rekbot?.id)
        .subscribe({
          next: (response: any) => {
            console.log("decodeLocationData", response)
            if (response.error !== undefined) {
              this.notificationService.pushNotification(
                response.error, 'error', 5000);
            } else {
              this.notificationService.pushNotification(
                `Lokalizacja zdekodowana`, 'info', 5000);
            }          },
          error: (error) => {
            console.log("decodeLocationData error", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        });
    }

  }

  setStdLocation() {
    this.rekbotSettings.street = "Generała Władysława Sikorskiego 6b";
    this.rekbotSettings.city = "Łajski";
    this.rekbotSettings.post_code = "05-119";
    this.rekbotSettings.country = "Polska";

  }
}
